import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { app } from '../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      show: 'none'
    }
  }

  formSubmit(event) {
    event.preventDefault()

    const name = this.nameInput.value
    const file = this.fileInput.files[0]
    const fileVal = this.fileInput.value
    //console.log(name+"-"+fileVal)
    
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(fileVal)[1];

    if (name == '' || fileVal == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    var ref = app.database().ref('brands').push();
    this.setMessage('Uploading...');
    var uploadRef = app.storage().ref().child('images/brands/'+ref.key+'.'+ ext);
    var uploadTask = uploadRef.put(file);
    uploadTask.on('state_changed', (storeSnap)=>{
      //console.log('processing')
    }, (error)=>{
      this.setMessage('Upload error');
    }, ()=>{
      //console.log(uploadTask.snapshot.downloadURL);
      ref.set({
        image: uploadTask.snapshot.downloadURL,
        name: name
      })
      .then((dbSnap)=>{
        this.setMessage('Brand saved');
        this.entryForm.reset()
      })
      .catch((error)=>{
        uploadRef.delete();
        this.setMessage(error.message);
      });
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <ShowMessage show={this.state.show} message={this.state.message} />
                  <form onSubmit={(event) => { this.formSubmit(event) }} ref={(form) => { this.entryForm = form }}>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Brand Name" innerRef={(input) => { this.nameInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="file" name="file" innerRef={(input) => { this.fileInput = input }} />
                    </InputGroup>
                    <Button color="success" block>Submit</Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/views/Brands/Form.js